/**
 * ЗОНА ДЕЙСТВИЯ отряда на поле: куда может выстрелить катапульта или отряд эльфов, куда
 * дотягиваются соблазнение суккубов и способности гоблинов. Вместо затемнения всего лишнего
 * зона светится сама: от отряда кольцами расходится волна и прочерчивает контур зоны, по контуру
 * бегут огоньки, внутри мягкий теплый свет. Снаружи легкая тень, ячейки в пределах дальности,
 * закрытые препятствием, заштрихованы. Отряды остаются яркими: все это лежит под ними.
 *
 * Рисует scenes/FieldRangeZone, геометрию считает utils/effects/rangeZoneGeometry.
 * Размеры — доли размера ячейки.
 */

export const RANGE_ZONE_TEXTURE_KEYS = {
  HATCH: 'range_zone_hatch',
};

export const RANGE_ZONE = {
  // Красно-оранжевый цвет войны: золото занято обводками целей и выбранной ячейки
  palette: {core: 0xffecd6, halo: 0xff5424, mote: 0xfff6e1, light: 0xff9646, shadow: 0x140a03, targetPop: 0xffb81f},
  outsideDimAlpha: 0.2,
  hatchAlpha: 0.5,
  // Волна при выборе отряда: столько на кольцо ячеек, запас после последнего кольца
  wave: {ringMs: 110, revealExtraRings: 1.2, widthRings: 1.1, alpha: 0.42},
  // Свет внутри зоны: у отряда и на краю, дыхание вокруг этих значений
  // Сильнее не надо: свет складывается с подложкой и на снегу выбеливает ячейки
  light: {nearAlpha: 0.14, farAlpha: 0.05, fadeMs: 160, breathMs: 5600, breathScale: 0.12},
  // Слабый повторный импульс, пока отряд выбран. При осмотре его нет
  ping: {delayMs: 900, periodMs: 3600, ringMs: 170, widthRings: 1.2, alpha: 0.14},
  contour: {
    coreWidthFactor: 0.13,
    haloWidthFactor: 0.6,
    shadowWidthFactor: 0.34,
    // Концы полос заходят друг на друга: на углу нет зазора, а вершины чуть ярче
    overlapFactor: 0.25,
    shadowAlpha: 0.6,
    breathMs: 4400,
    minHaloAlpha: 0.6,
    maxHaloAlpha: 1,
    // Вспышка контура в момент, когда волна его прочертила
    flashMs: 500,
  },
  motes: {spacingFactor: 7, speedFactor: 2, sizeFactor: 0.42},
  // Обводка цели вздрагивает, когда до нее дошла волна
  targetPop: {durationMs: 420, maxScale: 1.3},
};
